import { createAction, props } from '@ngrx/store';
import { UserActionTypes } from './action-types';

export const UPDATE_POINTS_COUNT = createAction(
  UserActionTypes.UpdatePointsCount,
  props<{ pointsCount: number }>()
);

export const MARK_ALL_NOTIFICATIONS_AS_READ = createAction(
  UserActionTypes.MarkAllNotificationsAsRead
);

export const MARK_ONE_NOTIFICATION_AS_READ = createAction(
  UserActionTypes.MarkOneNotificationAsRead
);

export const SET_UNREAD_NOTIFICATIONS_COUNT = createAction(
  UserActionTypes.SetUnreadNotificationsCount,
  props<{ unreadNotificationCount: number }>()
);
